import { ExtraTipsResponse } from 'store/slices/mentions/types'
import { ExtraTip } from 'store/types'
import { mapMedia } from './TimeLineMapper'

export const extraTipsMapper = (extraTips: ExtraTipsResponse): ExtraTip => ({
  attachment: mapMedia(extraTips.attachment),
  id: extraTips.id,
  properties: JSON.parse(extraTips.properties),
})
